import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getSingleModelTask } from "services/models/modelDetails/modelTasks";

const DETAIL_STALE_TIME = 5 * 60 * 1000;

const modelTaskDetailKey = (taskId) => ["modelTaskDetail", taskId];

const useModelTaskDetail = ({ taskId, enabled }) => {
	const queryClient = useQueryClient();
	const query = useQuery({
		queryKey: modelTaskDetailKey(taskId),
		enabled: Boolean(enabled && taskId),
		staleTime: DETAIL_STALE_TIME,
		queryFn: async ({ signal }) => {
			const response = await getSingleModelTask(taskId, signal);
			if (!response?.status || !response.data?.[0]) {
				throw new Error(response?.data?.title || "something went wrong");
			}
			return response.data[0];
		},
	});

	const setTask = useCallback(
		(updater) => queryClient.setQueryData(modelTaskDetailKey(taskId), updater),
		[queryClient, taskId]
	);

	return { task: query.data, error: query.error, setTask };
};

export { modelTaskDetailKey };
export default useModelTaskDetail;
